'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Architecture(eyebrow, title, lead, mapTitle, mapHint, layers, foundationTitle, foundationText, link, note) {
  this.gd = null;
  this.gm = null;
  this.gh = null;
  this.gk = null;
  this.gj = null;
  this.gg = null;
  this.gf = null;
  this.ge = null;
  this.gi = null;
  this.gl = null;
  this.gd = eyebrow;
  this.gm = title;
  this.gh = lead;
  this.gk = mapTitle;
  this.gj = mapHint;
  this.gg = layers;
  this.gf = foundationTitle;
  this.ge = foundationText;
  this.gi = link;
  this.gl = note;
}
export { $c_Lio_intela_sites_intelacloud_content_Architecture as $c_Lio_intela_sites_intelacloud_content_Architecture };
$p = $c_Lio_intela_sites_intelacloud_content_Architecture.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Architecture;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Architecture() {
}
export { $h_Lio_intela_sites_intelacloud_content_Architecture as $h_Lio_intela_sites_intelacloud_content_Architecture };
$h_Lio_intela_sites_intelacloud_content_Architecture.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-1821811498), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Architecture)) {
    if ((this.gd === x$0.gd)) {
      var x = this.gm;
      var x$2 = x$0.gm;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if (((($x_3 && (this.gh === x$0.gh)) && (this.gk === x$0.gk)) && (this.gj === x$0.gj))) {
      var x$3 = this.gg;
      var x$4 = x$0.gg;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ((($x_2 && (this.gf === x$0.gf)) && (this.ge === x$0.ge))) {
      var x$5 = this.gi;
      var x$6 = x$0.gi;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.gl === x$0.gl);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 10;
});
$p.I = (function() {
  return "Architecture";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gd;
      break;
    }
    case 1: {
      return this.gm;
      break;
    }
    case 2: {
      return this.gh;
      break;
    }
    case 3: {
      return this.gk;
      break;
    }
    case 4: {
      return this.gj;
      break;
    }
    case 5: {
      return this.gg;
      break;
    }
    case 6: {
      return this.gf;
      break;
    }
    case 7: {
      return this.ge;
      break;
    }
    case 8: {
      return this.gi;
      break;
    }
    case 9: {
      return this.gl;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Architecture(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bl)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Architecture as $isArrayOf_Lio_intela_sites_intelacloud_content_Architecture };
var $d_Lio_intela_sites_intelacloud_content_Architecture = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Architecture, "io.intela.sites.intelacloud.content.Architecture", ({
  bl: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Architecture as $d_Lio_intela_sites_intelacloud_content_Architecture };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Architecture.js.map
